import React from 'react'
import { Text, Container, Heading, Input, Textarea } from '@chakra-ui/react'

import { StageDataSelect } from 'modules/stages'
import { SectorDataSelect } from 'modules/sector'
import {
  ProjectPhaseDataSelect,
  ProjectTargetDataSelect,
  ProjectImpactDataSelect,
  ProjectTechniqueDataSelect,
  ProjectTechnologyDataSelect,
  ProjectTechnologyEmergingDataSelect
} from 'modules/project'
import { FormField, FieldList, FieldListItem, WizardStepForm } from 'components'

export const UserRegistrationStep4 = props => (
  <WizardStepForm {...props} justify='center'>
    <Heading size='2xl' textAlign='center' my={5}>
      Dados do Projeto
    </Heading>
    <Container my={5}>
      <Text textAlign='end'  color='red.500'>* Resposta obrigatória</Text>
      <FieldList my={3} variant='vertical'>
        <FieldListItem isRequired label='Designação do projeto'>
          <FormField name='project.name'>
            <Input type='text' />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='Setor de aplicação'>
          <FormField name='project.sectors[].id'>
            <SectorDataSelect isMultiple />
          </FormField>
        </FieldListItem>

        <FieldListItem
          isRequired
          label='Contexto em que se desenvolve o projeto de IA (Nível de Maturidade)'>
          <FormField name='project.stage.id'>
            <StageDataSelect />
          </FormField>
        </FieldListItem>

        <FieldListItem
          isRequired
          label='Objetivos do projeto'
          helperText='limite de 1000 caracteres, frases curtas e verbos no infinito'>
          <FormField name='project.goals'>
            <Textarea maxLength={1000} />
          </FormField>
        </FieldListItem>

        <FieldListItem
          isRequired
          label='Resultados esperados'
          helperText='limite de 1000 caracteres, frases curtas'>
          <FormField name='project.expectedResults'>
            <Textarea maxLength={1000} />
          </FormField>
        </FieldListItem>

        <FieldListItem
          isRequired
          label='Aplicação (ex. compliance, agricultura de precisão, automação industrial, etc.)'
          helperText='limite de 250 caracteres, apenas uma frase'>
          <FormField name='project.application'>
            <Input type='text' maxLength={250} />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='Técnica'>
          <FormField name='project.techniques[].id'>
            <ProjectTechniqueDataSelect isMultiple />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='Etapa do projeto'>
          <FormField name='project.phase.id'>
            <ProjectPhaseDataSelect />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='Objeto do projeto'>
          <FormField name='project.target.id'>
            <ProjectTargetDataSelect />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='Impacto esperado'>
          <FormField name='project.impact.id'>
            <ProjectImpactDataSelect />
          </FormField>
        </FieldListItem>

        <FieldListItem
          isRequired
          label='Framework, IDE, Simulador, Linguagem e Biblioteca utilizados no projeto'>
          <FormField name='project.technologies[].id'>
            <ProjectTechnologyDataSelect isMultiple />
          </FormField>
        </FieldListItem>

        <FieldListItem isRequired label='Tecnologias emergentes aplicadas no projeto'>
          <FormField name='project.technologiesEmerging[].id'>
            <ProjectTechnologyEmergingDataSelect isMultiple />
          </FormField>
        </FieldListItem>
      </FieldList>
    </Container>
  </WizardStepForm>
)

export default UserRegistrationStep4
